import { render, staticRenderFns } from "./FreeFormView.vue?vue&type=template&id=32122bcd&"
import script from "./FreeFormView.vue?vue&type=script&lang=js&"
export * from "./FreeFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports